(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banniere-kits-deco"] && !Shopify.designMode) return;
  try {
    
  /* Défilé des kits déco de la bannière : démarre quand la bannière entre
     dans le champ, s'arrête quand elle en sort. Cuts secs, pas de fondu. */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.kd-img[data-defile]').forEach(function (conteneur) {
      var vues = conteneur.querySelectorAll('.kd-vue');
      if (vues.length < 2) return;
      var delai = Number(conteneur.dataset.defile) || 400;
      var i = 0;
      var timer = null;

      function demarre() {
        if (timer) return;
        timer = setInterval(function () {
          vues[i].classList.remove('kd-vue-active');
          i = (i + 1) % vues.length;
          vues[i].classList.add('kd-vue-active');
        }, delai);
      }

      function stoppe() {
        clearInterval(timer);
        timer = null;
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entrees) {
          entrees.forEach(function (e) {
            if (e.isIntersecting) demarre();
            else stoppe();
          });
        }).observe(conteneur);
      } else {
        demarre();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrousel-videos"] && !Shopify.designMode) return;
  try {
    
  /* Chargement progressif, la section est basse dans la page :
     - rien ne se charge au chargement de la page (preload none, pas de src
       actif tant qu'on n'approche pas) ;
     - quand la section arrive à 600 px du bas de l'écran, on charge les
       cartes visibles dans le rail plus une demi-vue d'avance (4 visibles
       sur ordinateur → environ 6 chargées, 1 à 2 sur mobile → 2 à 3) ;
     - au défilement du rail (flèches ou doigt), les suivantes se chargent
       au fur et à mesure, toujours avec la même avance ;
     - lecture auto muette en boucle quand la carte est à l'écran, pause
       dès qu'elle en sort, pour ne jamais décoder 12 vidéos à la fois.
     Avec « réduire les animations » : pas de lecture auto, la vidéo garde
     son image et affiche des contrôles. */
  (function () {
    var sections = document.querySelectorAll('[data-carrousel-videos]');
    if (!sections.length) return;
    var reduits = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = 'IntersectionObserver' in window;

    function chargeVideo(v) {
      if (v.dataset.chargee) return;
      v.dataset.chargee = '1';
      if (v.dataset.poster) v.poster = v.dataset.poster;
      v.preload = 'auto';
      v.load();
    }

    sections.forEach(function (section) {
      var rail = section.querySelector('[data-vrail]');
      var videos = Array.prototype.slice.call(section.querySelectorAll('video.vh-video'));

      if (!videos.length) return;

      if (reduits) {
        videos.forEach(function (v) { v.setAttribute('controls', ''); });
      }

      if (!io) {
        /* vieux navigateur : on charge tout, lecture directe */
        videos.forEach(function (v) { chargeVideo(v); if (!reduits) { v.muted = true; v.play().catch(function () {}); } });
        return;
      }

      /* 1. proximité verticale de la section */
      var proche = false;
      var dansRail = {};
      function majChargement() {
        if (!proche) return;
        videos.forEach(function (v) {
          if (dansRail[v.dataset.i]) chargeVideo(v);
          else if (v.dataset.poster && !v.poster) v.poster = v.dataset.poster;
        });
      }
      videos.forEach(function (v, i) { v.dataset.i = i; });

      var ioSection = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          proche = true;
          ioSection.disconnect();
          majChargement();
        });
      }, { rootMargin: '600px 0px' });
      ioSection.observe(section);

      /* 2. position dans le rail : visible ou à moins d'une vue complète
         (les flèches avancent d'une vue : la suivante doit déjà être là) */
      var ioRail = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          dansRail[e.target.dataset.i] = e.isIntersecting;
        });
        majChargement();
      }, { root: rail, rootMargin: '0px 100%' });
      videos.forEach(function (v) { ioRail.observe(v); });

      /* flèches : on charge la vue de destination avant de la faire glisser */
      section.querySelectorAll('[data-defile]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sens = parseInt(btn.dataset.defile, 10);
          var cible = rail.scrollLeft + rail.clientWidth * sens;
          videos.forEach(function (v) {
            var g = v.closest('.vcard').offsetLeft;
            if (g >= cible - rail.clientWidth && g < cible + rail.clientWidth * 2) chargeVideo(v);
          });
          rail.scrollBy({ left: rail.clientWidth * sens, behavior: reduits ? 'auto' : 'smooth' });
        });
      });

      /* 3. lecture quand la carte est vraiment à l'écran, pause sinon */
      if (reduits) return;
      var ioLecture = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            chargeVideo(v);
            v.muted = true;
            var p = v.play();
            if (p) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      videos.forEach(function (v) { ioLecture.observe(v); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var d = document.documentElement;

    /* ===== Coins du header =====
       Arrondis tant que le header chevauche le bandeau d'annonce,
       aplatis dès qu'il est collé en haut de l'écran au scroll. */
    var smHeader = document.querySelector('.sm-header');
    if (smHeader) {
      var porteur = smHeader.parentElement; /* le wrapper de section, qui porte le sticky */
      var stuckPlanifie = false;
      function majStuck() {
        stuckPlanifie = false;
        smHeader.classList.toggle('stuck', porteur.getBoundingClientRect().top <= 0);
      }
      window.addEventListener('scroll', function () {
        if (!stuckPlanifie) {
          stuckPlanifie = true;
          requestAnimationFrame(majStuck);
        }
      }, { passive: true });
      majStuck();
    }

    /* ===== Mega menu desktop =====
       Ouverture au survol avec intention, clic = navigation.
       Clavier : flèche bas ouvre le panneau, Échap ferme, Tab hors du header ferme. */
    var navItems = document.querySelectorAll('.nav-item');
    var tOuvre = null;
    var tFerme = null;

    function fermerMegas() {
      navItems.forEach(function (it) {
        it.classList.remove('open');
        var a = it.querySelector('a');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }

    function ouvrirMega(item) {
      fermerMegas();
      item.classList.add('open');
      item.querySelector('a').setAttribute('aria-expanded', 'true');
    }

    navItems.forEach(function (it) {
      if (!it.querySelector('.mega')) return;
      it.addEventListener('mouseenter', function () {
        clearTimeout(tFerme);
        tOuvre = setTimeout(function () { ouvrirMega(it); }, 90);
      });
      it.addEventListener('mouseleave', function () {
        clearTimeout(tOuvre);
        tFerme = setTimeout(fermerMegas, 160);
      });
      it.querySelector('a').addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          ouvrirMega(it);
          var premier = it.querySelector('.mega a');
          if (premier) premier.focus();
        }
      });
    });

    document.addEventListener('focusin', function (e) {
      var h = document.querySelector('.sm-header');
      if (h && !h.contains(e.target)) fermerMegas();
    });

    /* ===== Drawer mobile + accordéons ===== */
    var burger = document.querySelector('.burger');
    var mnav = document.getElementById('mnav');

    function fermerMnav() {
      var etaitOuvert = d.classList.contains('mnav-open');
      d.classList.remove('mnav-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (etaitOuvert && burger) burger.focus();
    }

    if (burger && mnav) {
      burger.addEventListener('click', function () {
        var ouvert = d.classList.toggle('mnav-open');
        burger.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      });
      mnav.querySelector('.mnav-close').addEventListener('click', fermerMnav);
      mnav.querySelectorAll('button.mnav-top').forEach(function (b) {
        b.addEventListener('click', function () {
          var ouvert = b.parentElement.classList.toggle('open');
          b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { fermerMegas(); fermerMnav(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack"] && !Shopify.designMode) return;
  try {
    
  /* Prix du pack : à l'arrivée sur la section, le gros prix part du total
     « séparé » et défile vers le bas jusqu'au prix du pack (une seule fois).
     Avec « réduire les animations », le prix du pack s'affiche directement. */
  (function () {
    var el = document.querySelector('.prix-pack .big[data-compte-de]');
    if (!el) return;
    var de = Number(el.dataset.compteDe);
    var vers = Number(el.dataset.compteVers);
    if (!de || !vers) return;

    function fmt(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      return;
    }

    el.textContent = fmt(de);

    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        /* petit retard : laisse l'animation d'entrée du pack se poser */
        setTimeout(function () {
          var debut = null;
          var duree = 1100;
          requestAnimationFrame(function pas(t) {
            if (!debut) debut = t;
            var x = Math.min((t - debut) / duree, 1);
            var ease = 1 - Math.pow(1 - x, 3);
            el.textContent = fmt(Math.round(de - (de - vers) * ease));
            if (x < 1) requestAnimationFrame(pas);
          });
        }, 650);
      });
    }, { threshold: 0.4 });
    io.observe(el);
  })();

  } catch(e) { console.error(e); }
})();
})();
